import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
const cookie = Cookies.get("user") || null;
const cookielog = Cookies.get("userlog") || null;

let userData = null;
if (cookie) {
  userData = JSON.parse(cookie);
}
let userDatalog = null;
if (cookielog) {
  userDatalog = JSON.parse(cookielog);
}
function getTime() {
  const now = new Date();
  let expireTime;

  if (now.getHours() >= 20) {
    expireTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      8,
      0,
      0
    );
  } else {
    expireTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      20,
      0,
      0
    );
  }

  return expireTime;
}

function setCookiesOnTimeandRole(user) {
  if (
    user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
    user.Role === process.env.REACT_APP_ROLE_ADMIN ||
    user.Role === process.env.REACT_APP_ROLE_PURCHASE ||
    user.Role === process.env.REACT_APP_ROLE_SALLE ||
    user.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
    user.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
    user.Role === process.env.REACT_APP_ROLE_OPS ||
    user.Role === process.env.REACT_APP_ROLE_INSPECTION ||
    user.Role === process.env.REACT_APP_ROLE_MARKETING ||
    user.Role === process.env.REACT_APP_ROLE_IT ||
    user.Role === process.env.REACT_APP_ROLE_SSM ||
    user.Role === process.env.REACT_APP_ROLE_ACCOUNTS ||
    user.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
    user.Role === process.env.REACT_APP_ROLE_CLIENT_FEEDBACK ||
    user.Role === process.env.REACT_APP_ROLE_HR ||
    user.Role === process.env.REACT_APP_ROLE_JR_HR ||
    user.Role === process.env.REACT_APP_ROLE_OFFICE_STAFF 
  ) {
    Cookies.set("user", JSON.stringify(user), { expires: getTime() });
  } else {
    Cookies.set("user", JSON.stringify(user), { expires: 7 });
  }
}
function setCookiesOnTimeandRoleLog(user) {
  if (
    user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
    user.Role === process.env.REACT_APP_ROLE_ADMIN ||
    user.Role === process.env.REACT_APP_ROLE_PURCHASE ||
    user.Role === process.env.REACT_APP_ROLE_SALLE ||
    user.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
    user.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
    user.Role === process.env.REACT_APP_ROLE_OPS ||
    user.Role === process.env.REACT_APP_ROLE_INSPECTION ||
    user.Role === process.env.REACT_APP_ROLE_MARKETING ||
    user.Role === process.env.REACT_APP_ROLE_IT ||
    user.Role === process.env.REACT_APP_ROLE_SSM ||
    user.Role === process.env.REACT_APP_ROLE_ACCOUNTS ||
    user.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
    user.Role === process.env.REACT_APP_ROLE_CLIENT_FEEDBACK ||
    user.Role === process.env.REACT_APP_ROLE_HR ||
    user.Role === process.env.REACT_APP_ROLE_JR_HR ||
    user.Role === process.env.REACT_APP_ROLE_OFFICE_STAFF 
  ) {
    Cookies.set("userlog", JSON.stringify(user), {
      expires: getTime(),
    });
  }
}

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    isLoggedIn: userData?.Token ? true : false,
    user: userData ? userData : null,
    userlog: userDatalog,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;

      setCookiesOnTimeandRole(action.payload);
    },
    userLoginLog: (state, action) => {
      state.userlog = action.payload;

      setCookiesOnTimeandRoleLog(action.payload);
    },
    logout: (state) => {
      Cookies.remove("user");
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    },
    finalOfficeLogout: (state) => {
      Cookies.remove("user");
      Cookies.remove("userlog");
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        userlog: null,
      };
    },
  },
});

export const { loginSuccess, logout, userLoginLog, finalOfficeLogout } =
  loginSlice.actions;
export default loginSlice.reducer;
